import { useEffect } from "react";

const PUBLIC_SCROLL_PATHS = new Set([
  "/login",
  "/accept-invitation",
  "/client-register",
  "/onboarding",
  "/workspace-setup",
]);

export default function usePublicPageScroll(
  pathname,
  isPasswordRecovery
) {
  useEffect(() => {
    const isPublicScrollRoute =
      PUBLIC_SCROLL_PATHS.has(pathname) ||
      isPasswordRecovery;

    if (!isPublicScrollRoute || typeof document === "undefined") {
      return;
    }

    [
      document.documentElement,
      document.body,
      document.getElementById("root"),
    ].forEach((element) => {
      if (!element) return;

      element.style.removeProperty("overflow");
      element.style.removeProperty("overflow-y");
    });
  }, [pathname, isPasswordRecovery]);
}